import { useState, useEffect } from 'react';

const useScrollSize = (ref) => {
  const [scrollWidth, setScrollWidth] = useState();
  const [scrollHeight, setScrollHeight] = useState();
  useEffect(() => {
    const getSize = () => {
      if (!ref?.current) {
        return;
      }
      setScrollWidth(ref.current.scrollWidth);
      setScrollHeight(ref.current.scrollHeight);
    };
    getSize();
    window.addEventListener("resize", getSize);
    return () => window.removeEventListener("resize", getSize);
  }, [ref]);
  return { scrollWidth, scrollHeight };
};

export { useScrollSize };
//# sourceMappingURL=useScrollSize.js.map
